// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__Cj8Dl","modal__container":"modal_modal__container__S6QFO","modal__close":"modal_modal__close__sd9dw","modal__header":"modal_modal__header__38OxW"};